module.exports = __webpack_public_path__ + "media/images/gba/2019/v2/isologotipo_c_blanco-202f4996e6bd757e62dc1687e3575765.svg";